<template>
  <div>
    <div style="margin-bottom: 16px">
      <div style="display: flex; align-items: center">
        <span
          style="flex: 1; font-size: 12px; font-weight: bold; color: #0f1a3a"
          >{{$t('carlineBinding.vehiclelist')}}</span
        >
      </div>
    </div>
    <div style="width: 100%">
      <!--搜索-->
      <el-form
        @submit.native.prevent
        :size="size"
        :model="form"
        label-width="0"
      
      >
        <el-form-item label="">
          <el-input
            prefix-icon="el-icon-search"
            v-model="form.CarNo"
            clearable
            :placeholder="$t('vehicle.carNoPls')"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="queryList"
            ></el-button
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <div style="height: calc(100vh - 500px); overflow: auto">
        <el-table
          v-loading="loading"
          size="mini"
          :data="tableData"
          @row-click="tableClickRow"
          border
          highlight-current-row
          style="width: 100%"
        >
          <el-table-column prop="CarNo" align="center" :label="$t('vehicle.carNo')">
          </el-table-column>
          <el-table-column prop="DeviceNo" align="center" :label="$t('vehicle.DeviceNo')">
          </el-table-column>
          <el-table-column prop="VelCount" align="center" :label="$t('arealimitset.areacount')">
            <template slot-scope="scope">
              {{ scope.row.VelCount }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="VehicleLastTime" align="center" :label="$t('vehicle.vehicleLastTime')">
            <template slot-scope="scope">
              {{ scope.row.VehicleLastTime }}
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <kl-pagination
        :total="total"
        @current-change="pageChange"
        :current-page.sync="form.PageNo"
      >
      </kl-pagination>
    </div>

    <div style="margin-bottom: 8px; margin-top: 8px">
      <div style="display: flex; align-items: center">
        <span
          style="flex: 1; font-size: 12px; font-weight: bold; color: #0f1a3a"
          >{{$t('arealimitset.vehiclebindarealist')}}</span
        >
        <div>
          <kl-label
            @click="onDelClick"
            :title="$t('arealimitset.delallarea')"
            icon="icon-icon_operat_delete"
            :iconSize="16"
            :fontSize="12"
            style="cursor: pointer"
          />
        </div>
      </div>
    </div>

    <div style="height: 140px; overflow: auto">
      <el-table
        v-loading="loadingDetail"
        size="mini"
        :data="tableDetailData"
        border
        @row-click="tableDetailClickRow"
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column prop="AreaName" align="center" :label="$t('arealimitset.areaname')">
        </el-table-column>
        <el-table-column prop="AreaType" align="center" :label="$t('areatype.title')">
          <template slot-scope="scope">
            <span v-if="scope.row.AreaType == 1">{{$t('areatype.rectangle')}}</span>
            <span v-if="scope.row.AreaType == 0">{{$t('areatype.circular')}}</span>
            <span v-if="scope.row.AreaType == 2">{{$t('areatype.polygon')}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    map: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      form: {
        CarNo: "",
        OperatorID: 0,
        QueryFlag: 2,

        QueryFlagExt: 1,
        PageNo: 1,
        PageSize: 10,
      },
      tableData: [],
      tableDetailData: [],
      total: 0,
      loading: false,
      loadingDetail: false,
      current_Vid: 0,
    };
  },
  computed: {
    size() {
      return this.$store.getters.size;
    },
    operator() {
      return this.$store.getters.operator;
    },
  },
  methods: {
    tableClickRow(row) {
      this.current_Vid = row.VehicleID;
      this.queryDetailList();
    },
    tableDetailClickRow(row) {
      if (!this.map) return;
      this.map.clearAll();
      
      if (row && (row.Lonlats || row.AddedInfo)) {
        switch (row.AreaType) {
          case 0:
            var circleInfo = row.AddedInfo.split(",");
            if (circleInfo.length == 3) {
              this.map.addCircle(
                row.AreaID,
                { lng: circleInfo[1], lat: circleInfo[2] },
                circleInfo[0]
              );
              this.map.setCenter(circleInfo[1], circleInfo[2]);
            }

            break;
          case 1: //矩形
            //todo  缩放到适当的区域
            var circleInfo = row.Lonlats.split(";");

            var ne = circleInfo[0].split(",");
            var sw = circleInfo[1].split(",");

            var lon = (parseFloat(ne[1]) + parseFloat(sw[1])) / 2;
            var lat = (parseFloat(ne[2]) + parseFloat(sw[2])) / 2;

            this.map.setCenter(lon, lat);

            var coordanites = [];
            coordanites.push({
              lng: parseFloat(ne[1]),
              lat: parseFloat(ne[2]),
            });
            coordanites.push({
              lng: parseFloat(ne[1]),
              lat: parseFloat(sw[2]),
            });
            coordanites.push({
              lng: parseFloat(sw[1]),
              lat: parseFloat(sw[2]),
            });
            coordanites.push({
              lng: parseFloat(sw[1]),
              lat: parseFloat(ne[2]),
            });

            this.map.addPolygon(
              "AREA1",
              row.AreaName,
              coordanites,
              3,
              0xcd3700,
              0xb3ee3a
            );

            break;
          case 2: //多边形
            //todo  缩放到适当的区域
            var circleInfo = row.Lonlats.split(";");

            var center = circleInfo[0].split(",");

            this.map.setCenter(parseFloat(center[1]), parseFloat(center[2]));

            var coordanites = [];
            circleInfo.forEach((element) => {
              var p = element.split(",");
              coordanites.push({
                lng: parseFloat(p[1]),
                lat: parseFloat(p[2]),
              });
            });

            this.map.addPolygon(
              "AREA1",
              row.AreaName,
              coordanites,
              3,
              0xcd3700,
              0xb3ee3a
            );

            break;
        }
      }
    },
    queryDetailList(VID) {
      this.loadingDetail = true;
      this.$api
        .querySpeedLimitAreaByVID({
          VehicleID: this.current_Vid,
          QueryFlag: 256,
        })
        .then((res) => {
          this.loadingDetail = false;

          this.tableDetailData = res.data;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //querySpeedLimitAreaByVID
    pageChange(page) {
      this.form.PageNo = page;
      this.queryList();
    },
    onDelClick() {
      //确认是否全部删除
      this.$confirm( this.$t('arealimitset.confirmdelallarea'),  this.$t('public.tips') , {
        confirmButtonText: this.$t('public.confirm')  ,
        cancelButtonText: this.$t('public.cancel') ,
        type: "warning",
      }).then(() => {
        this.$api
          .unbindVehicleAndArea({
            OperatorID: this.operator.OperatorId,
            VehicleID: this.current_Vid,
          })
          .then((res) => {
            this.$message({
              message:
              this.$t("arealimitset.msgistovehicle"),
              type: "success",
            });
            this.queryDetailList();
          })
          .catch((err) => {
            this.$message({
              message: this.$t('public.DeleteFail'),
              type: "error",
            });
          });
      });
    },
    queryList() {
      this.loading = true;

      this.form.OperatorID = this.operator.OperatorId;
      this.$api
        .querySpeedLimitVehicleInfo(this.form)
        .then((res) => {
          this.loading = false;
          this.total = res.count;
          this.tableData = res.data;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.queryList();
  },
};
</script>
